export * from "./userRole";

export enum ApplicationType {
  HOME_APP = 1,
  SUGGESTION_APP,
  CLAUSE_INFO_APP,
}

export enum SuggestionAppPage {
  SEARCH_SUGGESTION = 1,
  SUGGESTION_RESULT,
  SUGGESTION_FILTER,
}

export enum SuggestionSearchMode {
  SEMANTIC_SEARCH = 1,
  KEYWORD_SEARCH,
}

export enum ClauseCardMode {
  SUGGESTION = 1,
  BROWSE,
  DETAIL,
}

export enum QueryBuilderContext {
  CLAUSE_SEARCH = 1,
}

export enum FilterOperators {
  EQUAL = "EQUAL",
  NOT_EQUAL = "NOT_EQUAL",
  CONTAINS = "CONTAINS",
  NOT_CONTAINS = "NOT_CONTAINS",
  EMPTY = "EMPTY",
  NOT_EMPTY = "NOT_EMPTY",
  ANY = "ANY",
  ALL = "ALL",
  LESS_THAN = "LESS_THAN",
  LESS_THAN_OR_EQUAL = "LESS_THAN_OR_EQUAL",
  GREATER_THAN = "GREATER_THAN",
  GREATER_THAN_OR_EQUAL = "GREATER_THAN_OR_EQUAL",
  ARRAY_OVERLAPS = "ARRAY_OVERLAPS",
  ARRAY_CONTAINS = "ARRAY_CONTAINS",
  NOT_IN = "NOT_IN",
}

export enum WorkerMessageType {
  UNUSUAL_TEXT_TRIGRAM_COUNTS = "unusual-text-trigram-counts-work",
}

export enum RelatedObjectType {
  CLAUSE = "CLAUSE",
  DOCUMENT = "DOCUMENT",
  COMMENT = "COMMENT",
  CHECKLIST = "CHECKLIST",
  REPORT = "REPORT",
  HEATMAP = "HEATMAP",
  WORKSPACE = "WORKSPACE",
  TAG = "TAG",
  TAG_CATEGORY = "TAG_CATEGORY",
  USER = "USER",
}
